@if (hasCases()) {
<section class="open-case-bar" aria-label="Open wells case bar">
  <div class="open-case-bar__content">
    <div
      #track
      [class.open-case-bar__track--expanded]="expanded()"
      class="open-case-bar__track"
    >
      @for (caseItem of cases(); track caseItem.id) {
      <div
        [class.open-case-pill--active]="activeCaseId() === caseItem.id"
        class="open-case-pill"
      >
        <button
          [title]="getTooltip(caseItem)"
          (click)="onSelectCase(caseItem)"
          type="button"
          class="open-case-pill__select"
        >
          {{ caseItem.label }}
        </button>
        <button
          [attr.aria-label]="('app.forms.close' | translate) + ' ' + caseItem.label"
          (click)="onCloseCase($event, caseItem.id)"
          type="button"
          class="open-case-pill__close"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
      }
    </div>

    <div class="open-case-bar__actions">
      <button
        (click)="onClearAll()"
        type="button"
        class="centaur-button xs secondary open-case-bar__clear"
      >
        {{ 'common.clear' | translate }}
      </button>

      @if (canToggleExpansion()) {
      <button
        [attr.aria-label]="(expanded() ? 'common.collapse' : 'common.expand') | translate"
        [attr.aria-expanded]="expanded()"
        [title]="(expanded() ? 'common.collapse' : 'common.expand') | translate"
        (click)="toggleExpanded()"
        type="button"
        class="open-case-bar__toggle"
      >
        <i
          [class.pi-chevron-up]="expanded()"
          [class.pi-chevron-down]="!expanded()"
          class="pi"
        ></i>
      </button>
      }
    </div>
  </div>
</section>
}
